<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title title-typography-color">
          <i aria-hidden="true" class="fa fa-file"></i>
          Encuesta
        </h4>
      </template>
      <template v-slot:headerAction>
        <b-button v-if="mode === 'PREVIEW'" class="mr-2" style="right" variant="primary"
          @click="goToContactSurvey">Atras
        </b-button>
        <b-button v-if="mode !== 'PREVIEW'" class="mr-2" style="right" variant="success" @click="store">{{
          $t("public.views.Pages.Rating.btnSave")
        }}
        </b-button>
      </template>
      <template v-slot:body>
        <tab-nav :tabs="true">
          <tab-nav-items v-for="(option, index) in survey.tabs" :id="'tab-nav-' + index" :key="index"
            :active="index < 1" :ariaSelected="true" :href="'#tab-' + index" role="tab">
            <template v-slot:title>
              {{ option.name }}
            </template>
          </tab-nav-items>
        </tab-nav>
        <tab-content>
          <tab-content-item v-for="(option, index) in survey.tabs" :id="'tab-' + index" :key="index"
            :active="index < 1">
            <div class="test-survey-builder">
              <b-row>
                <b-col v-for="(question, index) in option.questionsList" :key="index" :cols="12">
                  <div class="p-0">
                    <div class="question-section">
                      <p v-if="
                        completeCheck &&
                        (question.value === null ||
                          question.value === undefined ||
                          question.value === '')
                      " class="question_body text-danger">
                        {{ question.body }}
                      </p>
                      <p v-else class="question_body">{{ question.body }}</p>
                    </div>
                    <div class="answer-section">
                      <div v-if="question.type === 'BOOLEAN'" class="option-section">
                        <b-form-group v-slot="{ ariaDescribedby }">
                          <b-form-radio v-for="(option, index) in question.options" :key="index"
                            v-model="question.value" :aria-describedby="ariaDescribedby" :disabled="readOnly"
                            :name="'booleanSelect' + question.uuid" :value="option.body">{{ option.body }}
                          </b-form-radio>
                        </b-form-group>
                      </div>
                      <div v-if="question.type === 'TEXT'" class="option-section">
                        <b-form-input v-if="question.characterLimited" v-model="question.value"
                          :maxlength="question.textLimit" :readonly="readOnly" min="0" type="text" />
                        <b-form-input v-if="!question.characterLimited" v-model="question.value" :readonly="readOnly"
                          type="text" />
                      </div>
                      <div v-if="question.type === 'FILE'" class="option-section">
                        <vue-dropzone :id="'dropzone' + question.uuid" :options="dropzoneOptions" @vdropzone-success="
                          vdropzoneSuccess(question, ...arguments)
                        "></vue-dropzone>
                      </div>
                      <div v-if="question.type === 'DATE'" class="option-section">
                        <date-picker v-model="question.valueTmp" :format="myFormat" :formatter="momentFormat"
                          :readonly="readOnly" type="date" @pick="updateDate(question)"></date-picker>
                      </div>
                      <div v-if="question.type === 'TIME'" class="option-section">
                        <vue-timepicker v-model="question.valueTmp" :readonly="readOnly"
                          @change="updateTime(question)"></vue-timepicker>
                      </div>
                      <div v-if="question.type === 'NUMBER'" class="option-section">
                        <div>
                          <b-form-input v-if="question.hasMinMax && !question.allowDecimals" v-model="question.value"
                            :max="question.maxValue" :min="question.minValue" :readonly="readOnly" type="range">
                            {{ question.value }}
                          </b-form-input>
                          <b-form-input v-if="!question.hasMinMax && question.allowDecimals" v-model="question.value"
                            :readonly="readOnly" step="0.01" type="number">
                          </b-form-input>
                          <b-form-input v-if="
                            !question.hasMinMax && !question.allowDecimals
                          " v-model="question.value" :readonly="readOnly" type="number">
                          </b-form-input>
                          <b-form-input v-if="question.hasMinMax && question.allowDecimals" v-model="question.value"
                            :max="question.maxValue" :min="question.minValue" :readonly="readOnly" step="0.01"
                            type="range">
                          </b-form-input>
                          <div v-if="question.hasMinMax">
                            {{ question.value }}
                          </div>
                        </div>
                      </div>
                      <div v-if="question.type === 'SINGLE_CHOICE'" class="option-section">
                        <b-form-group v-slot="{ ariaDescribedby }" @input="multiChoiceTransformJson(question)">
                          <b-form-radio v-for="(option, index) in question.options" :key="index"
                            v-model="question.value" :aria-describedby="ariaDescribedby" :disabled="readOnly"
                            :value="option.body" name="singleSelect">{{ option.body }}
                          </b-form-radio>
                        </b-form-group>
                      </div>

                      <div v-if="question.type === 'RATING'" class="option-section">
                        <b-form-survey :id="'survey' + question.uuid" v-model="question.value"
                          variant="warning"></b-form-survey>
                      </div>
                      <div v-if="question.type === 'TEXTAREA'" class="option-section">
                        <b-form-textarea :id="'textarea' + question.uuid" v-model="question.value" max-rows="6"
                          rows="3"></b-form-textarea>
                      </div>
                      <div v-if="question.type === 'EDITOR'" class="option-section">
                        <ckeditor :id="'ckeditor' + question.uuid" v-model="question.value" :config="configCK"
                          type="classic"></ckeditor>
                      </div>
                      <div v-if="question.type === 'MULTI_CHOICE'" class="option-section">
                        <b-form-group v-slot="{ ariaDescribedby }">
                          <b-form-checkbox-group v-model="question.valueTmp"
                            @input="multiChoiceTransformJson(question)">
                            <b-form-checkbox v-for="(option, index) in question.options" :key="index"
                              :aria-describedby="ariaDescribedby" :name="'multiChoiceSelect' + question.uuid"
                              :value="option.sequence">{{ option.body }}
                            </b-form-checkbox>
                          </b-form-checkbox-group>
                        </b-form-group>
                      </div>
                      <div v-if="question.type === 'CORE'" class="option-section">
                        <b-form-group>
                          <b-form-group v-slot="{ ariaDescribedby }">
                            <span v-if="
                              question.coreWeight !== undefined &&
                              question.coreWeight !== null &&
                              mode === 'PREVIEW'
                            ">( {{ question.coreWeight }} )</span>
                            <b-form-radio v-for="(option, index) in question.options" :key="index"
                              v-model="question.value" :aria-describedby="ariaDescribedby" :disabled="readOnly"
                              :name="'coreSelect' + question.uuid" :value="option.weight">{{ option.body }}
                              <span v-if="
                                option.weight !== undefined &&
                                option.weight !== null &&
                                mode === 'PREVIEW'
                              ">( {{ option.weight }} )</span>
                            </b-form-radio>
                          </b-form-group>
                        </b-form-group>
                      </div>
                    </div>
                  </div>
                </b-col>
                <b-col>
                  <div class="text-right">
                    <b-button v-if="mode !== 'PREVIEW'" class="mr-2" style="right" variant="success" @click="store">{{
                      $t("public.views.Pages.Rating.btnSave")
                    }}
                    </b-button>
                  </div>
                </b-col>
              </b-row>
            </div>
          </tab-content-item>
        </tab-content>
      </template>
    </iq-card>
    <notifications group="notificacions" />
  </b-container>
</template>
<script>
import { xray } from "../../config/pluginInit";

import FiveOptionsCoreSelect from "../../json/FiveCoreOptions";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/es";

import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";

import moment from "moment";

import surveyService from "../../services/survey";

export default {
  name: "Survey",
  components: { DatePicker, VueTimepicker },
  mounted() {
    xray.index();
    if (localStorage.getItem("role") === "PATIENT") {
      if (this.$route.query.uuid && this.$route.query.mode) {
        this.mode = this.$route.query.mode;
        this.getTemplate(this.$route.query.uuid);
      } else {
        this.goToDashboard();
      }
    } else if (
      localStorage.getItem("role") !== "PATIENT" &&
      this.$route.query.mode === "PREVIEW"
    ) {
      this.getTemplate(this.$route.query.uuid);
    } else {
      this.goToDashboard();
    }
  },

  methods: {
    goToContactSurvey() {
      this.$router.push({
        name: "auth.professional.contact.survey",
      });
    },
    goToDashboardProfessional() {
      this.$router.push({
        name: "auth.professional.dashboard",
      });
    },
    goToDashboard() {
      if (localStorage.getItem("role") === "PATIENT") {
        this.$router.push({ name: "auth.patient.dashboard" });
      } else {
        this.$router.push({ name: "auth.professional.dashboard" });
      }
    },
    questionaryToSurvey() {
      let self = this;
      self.completeCheck = true;
      if (this.survey && this.survey.tabs && this.survey.tabs.length !== 0) {
        this.survey.tabs.forEach(function (tab) {
          if (tab && tab.questionsList && tab.questionsList.length !== 0) {
            tab.questionsList.forEach(function (question) {
              if (
                question.value !== "" &&
                question.value !== null &&
                question.value !== undefined
              ) {
                let obj = {
                  question: question.body === null ? "" : question.body,
                  value: question.value === null ? "" : question.value,
                  weight:
                    question.coreWeight === null ? "" : question.coreWeight,
                };
                self.variable.push(obj);
              } else {
                self.completeCheck = true;
                throw "No completed";
              }
            });
          }
        });
      }
    },
    async getTemplate(uuid) {
      let self = this;

      this.$awn.asyncBlock(
        surveyService.getTemplate(uuid),
        (response) => {
          if (response) {
            self.survey = response.data;
            console.log(self.survey);
          }
        },
        (error) => {
        },
        " "
      );
    },
    store() {
      let self = this;

      try {
        this.questionaryToSurvey();

        let obj = {
          surveyQuestions: this.variable,
          surveyId: this.$route.query.surveyId,
        };

        this.$awn.asyncBlock(
          surveyService.complete(obj),
          (response) => {
            if (response) {
              self.$router.push({
                name: "auth.patient.dashboard",
              });
            }
          },
          (error) => {
            this.goToDashboard();
            utilsService.auditErrorFrontent({
              info: "surveyService.complete",
              module: "view-pages-survey",
              httpStatus: error.response ? error.response.status : null,
              endpoint: window.location.href,
              request: JSON.stringify({
                obj: obj
              })
            });
          },
          " "
        );
      } catch (error) {
        self.$swal({
          icon: "error",
          title: "Complete todos los campos",
        });
      }
    },
    vdropzoneSuccess: function (question, file, response) {
      question.value =
        process.env.VUE_APP_BASE_URL_CORE + "public/file/" + response.uuid;
    },
    multiChoiceTransformJson(question) {
      let str = "";
      if (
        question.valueTmp &&
        (question.type === "MULTI_CHOICE" ||
          question.type === "SINGLE_CHOICE" ||
          question.type === "BOOLEAN")
      ) {
        if (question.options && question.options.length !== 0) {
          question.options.forEach(function (option) {
            if (question.valueTmp.includes(option.sequence)) {
              if (str) {
                str = str + " - " + option.body;
              } else {
                str = option.body;
              }
            }
          });
        }

        question.value = str;
      }
    },
    updateTime(question) {
      if (question.valueTmp) {
        question.value = question.valueTmp.HH + ":" + question.valueTmp.mm;
      }
    },
    updateDate(question) {
      question.value = moment(question.valueTmp).format("DD/MM/yyyy");
    },
  },

  data() {
    return {
      mode: "PREVIEW",
      fiveOptionsCoreSelect: FiveOptionsCoreSelect,
      organizationId: localStorage.getItem("organizationId"),
      //Form dynamic
      readOnly: false,
      configCK: {
        fillEmptyBlocks: false,
        basicEntities: false,
        entities: false,
        entities_greek: false,
        entities_latin: false,
        entities_additional: "",
        language: "es",
      },
      //vue2-data-picker
      myFormat: "DD/MM/YYYY",
      momentFormat: {
        //[optional] Date to String
        stringify: (date) => {
          return date ? moment(date).format("LL") : "";
        },
        //[optional]  String to Date
        parse: (value) => {
          return value ? moment(value, "LL").toDate() : null;
        },
        //[optional] getWeekNumber
        getWeek: (date) => {
          // a number
        },
      },
      dropzoneOptions: {
        url: process.env.VUE_APP_BASE_URL_CORE + "public/file/upload",
        thumbnailWidth: 200,
        maxFilesize: 2,
        addRemoveLinks: true,
        maxFiles: 1,
        dictDefaultMessage: "<i class='ri-upload-cloud-fill'></i>Subir",
      },
      //----
      survey: {},
      badge: {
        color: null,
        text: null,
      },
      variable: [],
      comments: "",
      completeCheck: false,
    };
  },
};
</script>
